"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeBatch = exports.nativeBatchResultSchema = exports.nativeBatchArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.nativeBatchArgsSchema = zod_1.z.object({
    array: zod_1.z.array(zod_1.z.any()).describe('The flat array to batch'),
    batchSize: zod_1.z.number().positive().describe('The size of each batch'),
    outputSchema: zod_1.z
        .string()
        .describe('The schema for the output batches as a JSON Schema. If T is the type of the object, the output schema should be {"type": "object", "properties": { "batches": {"type": "array", "items": {"type": "object", "properties": {"batch": {"type": "array", "items": {"type": "T"}}}}}}'),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single". If the input is a single array, the emit mode should be "single".'),
});
// Result schema
exports.nativeBatchResultSchema = zod_1.z.object({
    batches: zod_1.z
        .array(zod_1.z.object({
        batch: zod_1.z.array(zod_1.z.any()),
    }))
        .describe('Array of batch objects, each containing a batch array'),
});
// Tool definition
exports.nativeBatch = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeBatch',
    displayName: 'Batch Array',
    displayDescription: 'Convert a flat array into batches of a specified size',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'batch',
    argsSchema: exports.nativeBatchArgsSchema,
}, exports.nativeBatchResultSchema);
